export default {"src":"/_next/static/media/sauce.644be852.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};